<template>
 <div class="myContract">
    <div class="MyLoadHeadTab">
      <div
        v-for="(e, index) in tabArray"
        :key="e"
        :class="{ active: index === activeIndex }"
        @click="switchClick(index)"
      >
        <div class="myContractHeadTab_text">{{ e }}</div>
        <div
          class="myContractHeadTab_line_grey"
          :class="{ myContractHeadTab_line: index === activeIndex }"
        ></div>
      </div>
    </div>
    <div class="myContract_content">
       <slot name="headerLeft" v-if="activeIndex === 0"></slot>
       <slot name="headerRight" v-if="activeIndex === 1"></slot>
    </div>
 </div>
</template>

<script>

export default {
  name: 'myContract',
  data() {
    return {
      tabArray: ['订单协议', '其他协议'],
      ImgUrl: '',
      name: '',
      activeIndex: 0,
    };
  },
  methods: {
    switchClick(i) {
      this.activeIndex = i;
    },
  },
};
</script>
<style scoped>
.myContract{
  padding-top: 8px;
}
.MyLoadHeadTab {
  box-shadow: 0 4px 8px 0 rgba(0, 31, 51, 0.08);
  background: #fff;
  height: 48px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  border-radius: 3px 3px 0 0;
  margin: 0 16px 16px 16px;
  font-size: 16px;

}
.MyLoadHeadTab > div {
  height: 48px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  height: 100%;
}
.myContractHeadTab_text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  font-size: 16px;
  font-family: PingFangSC-Regular;
}
.myContractHeadTab_line {
  background: #f56446;
}
.myContractHeadTab_line_grey {
  width: 50px;
  height: 3px;
}
.active {
  font-family: PingFangSC-Medium;
  font-size: 32px;
  color: #f56446;
  font-weight: bold;
}
.mySet {
  color: #fff;
  font-size: 22px;
}

.bindEnterprise_img img{
  margin-top: 30px;
  width: 100%;
}
.bindEnterprise_img span {
  display: block;
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #b8c4cc;
  letter-spacing: 0;
  text-align: center;
  margin-bottom: 40px;
  margin-top: -90px;
}
</style>
